import { FilterQuery } from '@yes.technology/react-toolkit'

export const getFilterableMapQuery = (obs: string): FilterQuery => ({
  $and: [
    {
      'obs.des': {
        $eq: obs
      }
    }
  ]
})
